// extracted by mini-css-extract-plugin
export default {"description":"BotItem_description__XNKtS"};